import { onRequestSuccess, onResponseRejected } from "./interceptors";
import axios from "axios";
const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(onRequestSuccess, undefined);
axiosApiInstance.interceptors.response.use(undefined, onResponseRejected);

export default axiosApiInstance;
